import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../services/user.service';
import {User} from '../../models/user';
import {ObjectUtils} from '../utils/object.utils';


@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url = route.queryParams['target_url'];
    return this.isNotAuthenticated(url);
  }

  private isNotAuthenticated(targetUrl: string) {
    const currentUser = ObjectUtils.parseJSON(localStorage.getItem('user')) as User;
    if (currentUser) {
      if (targetUrl) {
        this.router.navigateByUrl(decodeURIComponent(targetUrl));
      } else if (this.userService.isInfluencer) {
        this.router.navigate(['dashboard', 'details']);
      } else {
        this.router.navigate(['/discover'], {queryParams: {activeAccount: this.userService.getCompanyId()}});
      }
      return false;
    } else {
      this.userService.resetActiveAccount();
      this.userService.clearAdvertiserData();
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/login.guard.ts